import { PHOTO_SETTING, PRINT_SETTING } from '../../utils/station/settings';
import { useStationSetting } from './useStationSetting';

export interface StationToggles {
  isPrintEnabled: boolean;
  isPhotoEnabled: boolean;
}

/** Both features are on unless ?print=false or ?photo=false switched them off */
export const useStationToggles = (): StationToggles => ({
  isPrintEnabled: useStationSetting(PRINT_SETTING),
  isPhotoEnabled: useStationSetting(PHOTO_SETTING),
});

export const useStationPrintEnabled = (): boolean =>
  useStationSetting(PRINT_SETTING);

export const useStationPhotoEnabled = (): boolean =>
  useStationSetting(PHOTO_SETTING);
